import React, { useEffect, useState } from "react";
import CustomInput from "../../../Components/Atoms/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import CustomDialog from "../../../Components/Molecules/CustomDialog";
import VisitorOtpVerification from "./VisitorOtpVerication";
import VisitorOtpSubmission from "./VisitorOtpSubmission";
import { COMPONENTS, DEFAULTS, OTP_ACTION } from "../../../Constant";
import { Delete, OpenInNew } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import {
  getSingleVisitorLogRequest,
  getVisitorLogsResponseClear,
  postMediaUploadRequest,
  postMediaUploadResponseClear,
} from "../../../Redux/VisitorLogs/VisitorLogsActions";
import {
  postOTPActionRequest,
  postOTPActionResponseClear,
} from "../../../Redux/VisitorLogs/VisitorLogsActions";
import toast from "react-hot-toast";
import * as Yup from "yup";
import { useFormik } from "formik";
import MaskingComponent from "../../../Components/Atoms/MaskingComponent/Index";
import { getMasterListRequest } from "../../../Redux/Master/MasterActions";
import { useSearchParams } from "react-router-dom";
import CustomDateTimePicker from "../../../Components/Atoms/CustomDatepicker/Index";
import moment from "moment-timezone";
import CustomSelect from "../../../Components/Atoms/CustomSelect";

const VisitorBasicInfo = ({
  formik,
  type,
  isVerified,
  setIsVerified,
  openVerify,
  handleOpenVerify,
  handleCloseVerify,
  open,
  handleClose,
  setOtpDetails,
}) => {
  const dispatch = useDispatch();
  const { getSingleVisitorLogsLoading, getSingleVisitorLogsResponse } =
    useSelector((state) => state.visitorLogReducer);

  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const { postOtpActionResponse } = useSelector(
    (state) => state.visitorLogReducer,
  );

  useEffect(() => {
    if (type === "edit") {
      dispatch(getSingleVisitorLogRequest({ _id: id }));
    }
  }, [type]);

  useEffect(() => {
    if (getSingleVisitorLogsLoading) return;
    if (type === "edit" && getSingleVisitorLogsResponse?.success) {
      const data = getSingleVisitorLogsResponse.data;
      Object.keys(formik.values).forEach((e) => {
        if (e === "other_details") {
          const other_details_data = {
            ...data[e],
            purpose_of_visit: data[e]?.purpose_of_visit?._id || "",
            type: data[e]?.type?._id || "",
            destination: data[e]?.destination?._id || "",
            client: data[e]?.client?._id || "",
          };
          formik.setFieldValue(e, other_details_data);
        } else if (e === "host_details") {
          const host_details_data = {
            ...data[e],
            host_department: data[e]?.host_department?._id || "",
          };
          formik.setFieldValue(e, host_details_data);
        } else {
          formik.setFieldValue(e, data[e] || "");
        }
      });
    }
  }, [getSingleVisitorLogsLoading, type, getSingleVisitorLogsResponse]);

  const [updateInterval, setUpdateInterval] = useState(null);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const otp_formik = useFormik({
    initialValues: {
      type: "EMAIL",
      email_value: "",
      number_value: "",
    },
    onSubmit: (values) => {
      dispatch(postOTPActionRequest({ ...values, action: "SENT" }));
      handleClose();
    },
    validationSchema: Yup.object().shape({
      type: Yup.string().required("Required"),
      email_value: Yup.string().when(["$type"], ([type], schema) => {
        if (type === "EMAIL") {
          return Yup.string()
            .matches(emailRegex, "Invalid email")
            .required("Required");
        }
        return schema;
      }),
      number_value: Yup.string().when(["$type"], ([type], schema) => {
        if (type === "SMS") {
          return Yup.number().required("Required");
        }
        return schema;
      }),
    }),
  });

  const { getUserResponse } = useSelector((state) => state.user);

  const time_zone =
    getUserResponse?.data?.settings?.time_zone || DEFAULTS.TIME_ZONE;

  //OPEN VERIFY MODAL
  useEffect(() => {
    if (postOtpActionResponse?.success) {
      toast.success(postOtpActionResponse?.message);
      if (postOtpActionResponse?.data?.action === OTP_ACTION.SENT) {
        setUpdateInterval(postOtpActionResponse?.data);
        handleOpenVerify();
      } else if (postOtpActionResponse?.data?.action === OTP_ACTION.VERIFY) {
        const { email_value, number_value, verification_mode } =
          postOtpActionResponse.data;
        const res = {
          email_value,
          number_value,
          verification_mode,
          otp_verified_on: moment(new Date()).tz(time_zone),
        };
        setOtpDetails(res);
        setIsVerified(true);
        handleCloseVerify();
      }
    }
    dispatch(postOTPActionResponseClear());
  }, [postOtpActionResponse]);

  const searchSchema = {
    filters: {
      search: {
        value: "",
      },
      status: {
        value: "ACTIVE",
      },
    },
  };

  useEffect(() => {
    dispatch(getMasterListRequest({ ...searchSchema, sort: "name:asc" }));
  }, []);

  //MEDIA

  const { postMediaUploadLoading, postMediaUploadResponse } = useSelector(
    (state) => state.visitorLogReducer,
  );
  useEffect(() => {
    if (postMediaUploadLoading) return;
    const media_data = postMediaUploadResponse?.data;
    if (media_data) {
      const { name, value } = media_data;
      const [section, field] = name.split(".");
      formik.setFieldValue(`${section}.${field}`, value);
      dispatch(postMediaUploadResponseClear());
    }
  }, [postMediaUploadLoading]);

  const handleFileChange = (e) => {
    let { files, name } = e.target;
    dispatch(
      postMediaUploadRequest({
        name,
        value: files[0],
      }),
    );
    e.target.value = null;
  };

  const handleFileDelete = (name) => {
    formik.setFieldValue(name, null);
  };

  const FileUploader = ({
    title,
    required = false,
    name,
    handleChange,
    error,
    value,
    handleDelete,
    disabled,
    handleBlur,
    accept = "*",
  }) => {
    const handleViewPdf = () => {
      if (typeof value === "object") {
        var fileURL = URL.createObjectURL(value);
        return window.open(fileURL);
      } else if (typeof value === "string") {
        return window.open(`${process.env.REACT_APP_DOMAIN}/${value}`);
      } else return;
    };
    return (
      <div className="vendor_file_uploader">
        <div className="d-flex">
          <p className="mb-1">{title}</p>
          {required && <p className="erroStar">*</p>}
        </div>
        <label className="vendor_file_ip_wrp d-flex flex-column ">
          <input
            hidden
            type="file"
            accept={accept}
            onChange={handleChange}
            onBlur={handleBlur}
            name={name}
            disabled={disabled}
          />
          <img src="/Assets/Images/CLOUD.png" width="30px" className="image" />
          <p className="w-100 flex-fill text-truncate">
            {value ? value : "Click to upload"}
          </p>
        </label>

        {error && (
          <>
            <p className="errMsg">{error}</p>
          </>
        )}
        {value && (
          <div className="d-flex align-items-center justify-content-center gap-2 my-2">
            <IconButton color="error" onClick={() => handleDelete(name)}>
              <Delete />
            </IconButton>
            <IconButton color="info" onClick={handleViewPdf}>
              <OpenInNew />
            </IconButton>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    dispatch(getVisitorLogsResponseClear());
  }, []);

  const [retrievedData, setRetrievedData] = useState();

  useEffect(() => {
    if (retrievedData) {
      const {
        id_type,
        nric_masking,
        nric,
        fin_masking,
        fin,
        basic_details: { name, email, contact_no },
      } = retrievedData;
      // if (id_type === "NRIC") {
      //   formik.setFieldValue("nric_masking", nric_masking);
      //   formik.setFieldValue("nric", nric);
      // } else {
      //   formik.setFieldValue("fin_masking", fin_masking);
      //   formik.setFieldValue("fin", fin);
      // }
      formik.setFieldValue("basic_details.name", name);
      formik.setFieldValue("basic_details.email", email || "");
      formik.setFieldValue("basic_details.contact_no", contact_no);
    }
  }, [retrievedData]);

  return (
    <>
      <CustomDialog
        maxWidth="md"
        title={"SEND OTP"}
        handleClose={handleClose}
        open={open}
      >
        <VisitorOtpSubmission formik={otp_formik} parent_formik={formik} />
      </CustomDialog>

      <CustomDialog
        maxWidth="md"
        title={"OTP VERIFICATION"}
        handleClose={handleCloseVerify}
        open={openVerify}
      >
        <div>
          <VisitorOtpVerification
            handleClose={handleCloseVerify}
            updateInterval={updateInterval}
            setIsVerified={setIsVerified}
            otp_formik={otp_formik}
          />
        </div>
      </CustomDialog>

      <div className="col-md-12 pt-0">
        <h6 className="mb-4">BASIC DETAILS</h6>
      </div>
      {/* <div className="row">
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">ID Type</p>
            <p className="erroStar">*</p>
          </div>
          <CustomSelect
            type="text"
            name="id_type"
            placeholder="SELECT ID TYPE"
            onChange={(e) => {
              formik.handleChange(e);
              formik.setFieldValue("nric_masking", "");
              formik.setFieldValue("nric", "");
              formik.setFieldValue("nric_char", "");
              formik.setFieldValue("fin_masking", "");
              formik.setFieldValue("fin", "");
              formik.setFieldValue("fin_char", "");
              formik.setFieldValue("passport", "");
            }}
            disabled={!isVerified}
            onBlur={formik.handleBlur}
            value={formik.values.id_type}
            formik={formik}
            data={[
              { name: "NRIC", value: "NRIC" },
              { name: "FIN", value: "FIN" },
              { name: "PASSPORT", value: "PASSPORT" },
            ]}
          />
        </div>
        <div className="col-md-4">
          {formik.values.id_type === "NRIC" && (
            <>
              <div className="d-flex">
                <p className="mb-1">NRIC(Example : S1234567T)</p>
                <p className="erroStar">*</p>
              </div>
              <MaskingComponent
                formik={formik}
                placeholder={"Enter NRIC"}
                masking_key={"nric_masking"}
                real_key={"nric"}
                char_key={"nric_char"}
                disabled={!isVerified}
                type={"search"}
                setRetrievedData={setRetrievedData}
              />
            </>
          )}
          {formik.values.id_type === "FIN" && (
            <>
              <div className="d-flex">
                <p className="mb-1">FIN (Example : F1234567T)</p>
                <p className="erroStar">*</p>
              </div>
              <MaskingComponent
                formik={formik}
                placeholder={"Enter FIN"}
                masking_key={"fin_masking"}
                real_key={"fin"}
                disabled={!isVerified}
                char_key={"fin_char"}
                setRetrievedData={setRetrievedData}
                type={"search"}
              />
            </>
          )}
          {formik.values.id_type === "PASSPORT" && (
            <>
              <div className="col-md-12">
                <div className="d-flex">
                  <p className="mb-1">Passport</p>
                  <p className="erroStar">*</p>
                </div>
                <CustomInput
                  type="text"
                  name="passport"
                  placeholder="Enter Passport No"
                  value={formik.values.passport}
                  disabled={!isVerified}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  formik={formik}
                />
              </div>{" "}
            </>
          )}
        </div>
      </div> */}
      <div className="row">
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Visitor Name</p>
            <p className="erroStar">*</p>
          </div>
          <CustomInput
            type="text"
            disabled={!isVerified}
            name="basic_details.name"
            placeholder="Enter Visitor Name"
            value={formik.values.basic_details?.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            formik={formik}
            errorMsg={
              formik.touched?.basic_details?.name &&
              formik.errors?.basic_details?.name
            }
          />
        </div>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Contact No</p>
            <p className="erroStar">*</p>
          </div>
          <CustomInput
            type="number"
            name="basic_details.contact_no"
            placeholder="Enter Contact No"
            value={formik.values.basic_details?.contact_no}
            onChange={formik.handleChange}
            disabled={!isVerified}
            onBlur={formik.handleBlur}
            formik={formik}
            errorMsg={
              formik.touched?.basic_details?.contact_no &&
              formik.errors?.basic_details?.contact_no
            }
          />
        </div>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Email</p>
          </div>
          <CustomInput
            type="text"
            name="basic_details.email"
            component={COMPONENTS.EMAIL}
            placeholder="Enter Email"
            value={formik.values.basic_details?.email}
            onChange={formik.handleChange}
            disabled={!isVerified}
            onBlur={formik.handleBlur}
            formik={formik}
            errorMsg={
              formik.touched?.basic_details?.email &&
              formik.errors?.basic_details?.email
            }
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="d-flex">
            <p className="mb-1">Address</p>
          </div>
          <CustomInput
            type="text"
            multiline={true}
            rows={5}
            name="basic_details.address_details"
            upperLabel={true}
            disabled={!isVerified}
            placeholder="Enter Address ..."
            value={formik.values.basic_details?.address_details}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            formik={formik}
          />
        </div>
        <div className="col-md-6">
          <div className="d-flex">
            <p className="mb-1">Description</p>
          </div>
          <CustomInput
            type="text"
            multiline={true}
            rows={5}
            name="basic_details.description"
            upperLabel={true}
            disabled={!isVerified}
            placeholder="Describe ..."
            value={formik.values.basic_details?.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            formik={formik}
          />
        </div>
      </div>

      <div className="col-md-12 pt-0">
        <h6 className="mb-4">CHECK-IN & OUT DETAILS</h6>
      </div>
      <>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Check-In</p>
            <p className="erroStar">*</p>
          </div>

          <CustomDateTimePicker
            timeZone={getUserResponse?.data?.settings?.time_zone}
            disabled={!isVerified}
            name="basic_details.check_in"
            value={formik.values.basic_details?.check_in}
            onChange={(e) => {
              formik.setFieldValue("basic_details.check_in", e);
            }}
            onBlur={formik.handleBlur}
            formik={formik}
            errorMsg={
              formik.touched?.basic_details?.check_in &&
              formik.errors?.basic_details?.check_in
            }
          />
        </div>
        <div className="col-md-4">
          <div className="d-flex">
            <p className="mb-1">Check-Out</p>
          </div>
          <CustomDateTimePicker
            timeZone={getUserResponse?.data?.settings?.time_zone}
            disabled={!isVerified}
            name="basic_details.check_out"
            value={formik.values.basic_details?.check_out}
            onChange={(e) => {
              formik.setFieldValue("basic_details.check_out", e);
            }}
            onBlur={formik.handleBlur}
            formik={formik}
            errorMsg={
              formik.touched?.basic_details?.check_out &&
              formik.errors?.basic_details?.check_out
            }
          />
        </div>
      </>
      <div className="col-md-12 pt-0 mt-4">
        <h6 className="mb-4">DOCUMENTS</h6>
      </div>
      <>
        <div className="col-md-6">
          <FileUploader
            title="Primary"
            handleChange={handleFileChange}
            handleDelete={handleFileDelete}
            accept="image/*"
            name="basic_details.primary"
            disabled={!isVerified}
            error={
              formik.touched?.basic_details?.primary &&
              formik.errors?.basic_details?.primary
            }
            value={formik.values.basic_details?.primary}
          />
        </div>
        <div className="col-md-6">
          <FileUploader
            title="Secondary"
            handleChange={handleFileChange}
            disabled={!isVerified}
            handleDelete={handleFileDelete}
            accept="image/*"
            name="basic_details.secondary"
            error={
              formik.touched?.basic_details?.secondary &&
              formik.errors?.basic_details?.secondary
            }
            value={formik.values.basic_details?.secondary}
          />
        </div>
      </>
    </>
  );
};

export default VisitorBasicInfo;
